import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';
import LayoutGrid from 'ggApp/shared/components/layout/grid';
import DivisionLine from 'ggApp/shared/components/layout/divisionLine';
import { CampaignsWidgetWithEvents } from 'ggApp/shared/components/widgets/CampaignsWidget';
import FallbackMarketingCard from 'ggApp/shared/components/widgets/CampaignsWidget/FallbackMC1';
import CampaignCarousel from 'ggApp/shared/components/widgets/CampaignCarousel';
import { TileMarketingWidgetWithEvents } from 'ggApp/shared/components/widgets/TileMarketingWidget';
import { UspCardsWidgetWithEvents } from 'ggApp/shared/components/widgets/UspCardsWidget';
import Reviews from 'ggApp/shared/components/widgets/ReviewsWidget';
import NewProductWidget from 'ggApp/shared/components/widgets/ProductWidget';
import Countdown from 'ggApp/shared/components/widgets/CountdownWidget';

const forYouElementStyles = css`
    margin: 0 5% 24px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin: 0 16px 8px;
    `}
`;

export const Campaign = styled(CampaignsWidgetWithEvents)`
    ${forYouElementStyles};
`;

export const Line = styled(DivisionLine)`
    ${forYouElementStyles};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin: 16px;
    `}
`;

export const FallbackMC1 = styled(FallbackMarketingCard)`
    ${forYouElementStyles};
`;

export const CampaignCarouselWidget = styled(CampaignCarousel)`
    ${forYouElementStyles};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin: 0;
    `}
`;

export const WidgetGrid = styled(LayoutGrid)`
    * > {
        min-height: 30vw;
    }

    @media (${screens.phone}) and (${screens.tabletMax}) {
        overflow: hidden;
    }

    @media (${screens.phone}) and (${screens.desktopMax}) {
        padding: 0% 16px;
        margin: 0;
    }
`;

const FullWidthWidgetStyles = css`
    grid-column: 1 / -1;
    margin-bottom: 32px !important;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        margin-bottom: 24px;
    }
`;

export const CountdownWidget = styled(Countdown)`
    ${FullWidthWidgetStyles}
`;

export const TileMarketingWidget = styled(TileMarketingWidgetWithEvents)`
    ${FullWidthWidgetStyles}
`;

export const UspCardsWidget = styled(UspCardsWidgetWithEvents)`
    ${FullWidthWidgetStyles}

    @media (${screens.phone}) and (${screens.tabletMax}) {
        margin-right: -32px;
    }
`;

export const ReviewsWidget = styled(Reviews)`
    ${FullWidthWidgetStyles}
`;

export const ProductWidget = styled(NewProductWidget)`
    ${FullWidthWidgetStyles}
`;
